import {
  AboutGridItem,
  AboutGridItemType,
  FeaturedWorkImagesLayoutType,
  FeaturedWorkKey,
} from "./types";

const createFeaturedWork = (
  types: AboutGridItemType[],
  imageKey: FeaturedWorkKey,
  videos: string[] = [],
  title: string,
  subtitle: string,
  description: string,
  layoutType: FeaturedWorkImagesLayoutType = FeaturedWorkImagesLayoutType.default
): AboutGridItem => {
  return { types, imageKey, videos, title, subtitle, description, layoutType };
};

const werewolf: AboutGridItem = createFeaturedWork(
  [
    AboutGridItemType.Game,
    AboutGridItemType.Unity,
    AboutGridItemType.CSharpServer,
  ],
  FeaturedWorkKey.werewolf_online,
  ["RhpxJVu3osw"],
  "Werewolf Online",
  "Multiplayer Game Inspired by Lupus in Tabula",
  "A 3D multiplayer game based on inspiration from Lupus in Tabula. Applied unique roles and rules."
);

const miniGames = createFeaturedWork(
  [
    AboutGridItemType.Game,
    AboutGridItemType.Unity,
    AboutGridItemType.CSharpServer,
  ],
  FeaturedWorkKey.minigames,
  ["utCDhH1DS50", "oER_rfqz5uY", "OsO5EN1MGko"],
  "Mini Games",
  "Local Multiplayer Games Using Mobile and PC",
  "A collection of local multiplayer games where the mobile device acts as the controller and the PC serves as the game console. Carried out a government-supported project using this game model."
);

const holdem = createFeaturedWork(
  [
    AboutGridItemType.Game,
    AboutGridItemType.Unity,
    AboutGridItemType.CSharpServer,
  ],
  FeaturedWorkKey.holdem,
  [],
  "Holdem",
  "Local multiplayer card game",
  "A local multiplayer Holdem game played with mobile controller and PC console, following the same concept as MiniGames.",
  FeaturedWorkImagesLayoutType.include_thumbnail
);

const pocketBall = createFeaturedWork(
  [
    AboutGridItemType.Game,
    AboutGridItemType.Unity,
    AboutGridItemType.CSharpServer,
  ],
  FeaturedWorkKey.pocket_ball,
  [],
  "Pocket Ball",
  "Local multiplayer pocket ball game",
  "A local multiplayer Pocket Ball game played with mobile controller and PC console, following the same concept as MiniGames."
);

// const sharpShooter = createFeaturedWork(
//   [AboutGridItemType.Game],
//   FeaturedWorkKey.sharp_shooter,
//   [],
//   "Sharp Shooter",
//   "TPS using socket multiplay",
//   ""
// );

const avatar = createFeaturedWork(
  [
    AboutGridItemType.Module,
    AboutGridItemType.Outsourcing,
    AboutGridItemType.Unity,
  ],
  FeaturedWorkKey.avatar_customizing,
  ["hv6FBOW3w60", "3XnvzjaQggY"],
  "Avatar Customizing",
  "3D avatar customizing module",
  "A module that allows the movement, rotation, and adjustment of individual body parts & joints of a 3D avatar."
);

const cms = createFeaturedWork(
  [
    AboutGridItemType.App,
    AboutGridItemType.Outsourcing,
    AboutGridItemType.Android,
    AboutGridItemType.SpringBoot,
  ],
  FeaturedWorkKey.cms,
  [],
  "Smart Media Board CMS",
  "Android set-top box application",
  "Maintained Android application for set-top boxes and server systems of media board CMS solution.",
  FeaturedWorkImagesLayoutType.include_thumbnail_mix
);

const face = createFeaturedWork(
  [
    AboutGridItemType.App,
    AboutGridItemType.Outsourcing,
    AboutGridItemType.Android,
  ],
  FeaturedWorkKey.face,
  [],
  "Face Detection",
  "Children Care Application Implementing Face Detection Using OpenCV",
  "Using OpenCV in Android Native environment to enable face detection via the camera. Upon detection, the image is automatically captured and then processed with Amazon Rekognition to distinguish the child's face using a pre-trained model."
);

const soundable = createFeaturedWork(
  [AboutGridItemType.App, AboutGridItemType.Company],
  FeaturedWorkKey.soundable,
  [],
  "Soundable Health",
  "Digital health application service",
  ""
);

const others = createFeaturedWork(
  [],
  FeaturedWorkKey.others,
  [],
  "Others",
  "5min",
  ""
);

export const featuredWorks: AboutGridItem[] = [
  werewolf,
  miniGames,
  pocketBall,
  holdem,
  avatar,
  // sharpShooter,
  face,
  cms,
  // others,
  // soundable,
];
